const e = () => !!(typeof window < "u" && window.document && window.document.createElement);
export {
  e as isBrowser
};
//# sourceMappingURL=is-browser.js.map
